import { Box, Button } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useExperience } from '../../../experiences/context';

export function MyLocationControl({ map, markerRef }) {
  const { isPhone } = useExperience();

  function handleClick() {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      const pos = { lat: coords.latitude, lng: coords.longitude };

      if (!markerRef.current) {
        markerRef.current = new window.google.maps.Marker({
          map,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: '#4285F4',
            fillOpacity: 1,
            strokeColor: 'white',
            strokeWeight: 2,
          },
        });
      }

      markerRef.current.setPosition(pos);
      map.panTo(pos);
      map.setZoom(14);
    });
  }

  return (
    <Box sx={{ m: 1 }}>
      <Button
        title="My Location"
        variant="contained"
        color="inherit"
        onClick={handleClick}
        sx={{
          pointerEvents: 'auto',
          minWidth: 0,
          width: isPhone ? 'auto' : 36,
          bgcolor: 'white',
          '@media (hover: none)': { '&:hover': { bgcolor: 'white' } },
          mb: 1,
          ...(isPhone && { borderRadius: 4, p: 1.5 }),
        }}
      >
        <MyLocationIcon
          fontSize="medium"
          sx={{ color: '#666', '&:hover': { color: '#333' } }}
        />
      </Button>
    </Box>
  );
}
